import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'faq', Record<UrlRegion, UrlEntry>> = {
  faq: {
    de: 'faq',
    'de-en': 'faq',
    es: 'preguntas-frecuentes',
    'es-en': 'faq',
    fr: 'faq',
    'fr-en': 'faq',
    gb: 'faq',
    nl: 'faq',
    'nl-en': 'faq',
    pt: 'faq',
    'pt-en': 'faq',
    us: 'faq',
    ww: 'faq',
  },
};
